import * as React from 'react';
import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useQuery } from 'react-query';
import apiClient from '../../request/http-common';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useMutation } from "react-query";
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import usePortfolioBalance from '../../hooks/usePortfolioBalance';
import { formatAdminFundingDetails } from '../../utils/balanceUtils';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

export default function ListFundings() {

    const { coinRates } = usePortfolioBalance();
    const [fundings, setfundings] = useState(null);
    const { isLoading: isLoadingfundings, refetch: getfundings } = useQuery(
        "show-fundings",
        async () => {
          return await apiClient.get("/api/show-fundings");
        },
        {
          enabled: false,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setfundings(res.data.fundings);
                const event2 = new Event('processed');
                window.dispatchEvent(event2);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );

      const [fundingId, setfundingId] = useState('');
      const [fundingType, setfundingType] = useState('');
      const [fundingStatus, setfundingStatus] = useState('');
      const [open2, setOpen2] = React.useState(false);

      const handleClose2 = () => {
      setOpen2(false);
    };
    const handleToggle2 = () => {
      setOpen2(!open2);
    };

const { isLoading: isUpdating, mutate: updatefunding } = useMutation(
      async () => {
        return await apiClient.post(`/api/update-funding`, {
          funding_id: fundingId,
          funding_status: fundingStatus,
        });
      },
      {
        onSuccess: (res) => {
            if (res.data.status === 'success') {
              localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
              setTimeout(() => {
                const event = new Event('newMessage');
                window.dispatchEvent(event);
              }, 1000);
              getfundings();
              handleClose2();
              const event2 = new Event('processed');
              window.dispatchEvent(event2);
            }
        },
        onError: (err) => {
          let errorMessage = err.response?.data || err ;
          localStorage.setItem('notification', JSON.stringify({message : `${errorMessage.message}`, 'type': 'error' }));
          const event = new Event('newMessage');
          window.dispatchEvent(event);
          const event4 = new Event('processed');
          window.dispatchEvent(event4);
        },
      }
    );

      useEffect(() => {
        getfundings();
      }, []);

  const getDate = (date) => new Date(date).toLocaleString();

  const selectedDetails = fundingType?.id
    ? formatAdminFundingDetails(fundingType, coinRates)
    : null;

  return (
    <div style={{marginTop: '75px'}}>
    <Container maxWidth="xl">
        <Typography mt={4} mb={2} sx={{ fontWeight: 'bold', fontSize: 20, textAlign: 'center', textTransform: 'uppercase' }} gutterBottom variant="h6" component="div">
        {isLoadingfundings ? 'Loading fundings...' : 'List of wallet fundings'}
      </Typography>
    <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
      {fundings !== null && (
      <Table sx={{ minWidth: 1200 }} size="small">
      <TableHead>
        <TableRow>
        <TableCell>User</TableCell>
        <TableCell>Email</TableCell>
        <TableCell align="right">USD deposited</TableCell>
        <TableCell align="right">Coin units</TableCell>
        <TableCell align="right">Rate @ booking</TableCell>
        <TableCell align="right">Live USD value</TableCell>
        <TableCell>Gateway</TableCell>
        <TableCell>Transaction ID</TableCell>
        <TableCell>Status</TableCell>
        <TableCell>Date</TableCell>
        <TableCell align="right">Edit</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {fundings.map((funding) => {
          const d = formatAdminFundingDetails(funding, coinRates);
          return (
          <TableRow key={funding.id}>
            <TableCell>{funding.user?.name}</TableCell>
            <TableCell sx={{ maxWidth: 180, wordBreak: 'break-all', fontSize: 12 }}>
              {funding.user?.email}
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600 }}>{d.usd}</TableCell>
            <TableCell align="right">{d.coinUnits}</TableCell>
            <TableCell align="right" sx={{ fontSize: 12 }}>{d.rate}</TableCell>
            <TableCell align="right">{d.liveUsd}</TableCell>
            <TableCell>{funding.gateway}</TableCell>
            <TableCell sx={{ fontSize: 12 }}>{funding.transaction_id}</TableCell>
            <TableCell>{funding.status}</TableCell>
            <TableCell sx={{ fontSize: 12, whiteSpace: 'nowrap' }}>{getDate(funding.created_at)}</TableCell>
            <TableCell align="right">
              <Button
                size="small"
                onClick={() => {
                  handleToggle2();
                  setfundingId(funding.id);
                  setfundingType(funding);
                  setfundingStatus('');
                }}
                startIcon={<EditIcon />}
              >
                Edit
              </Button>
            </TableCell>
          </TableRow>
          );
        })}
      </TableBody>
    </Table>
      )}
    </TableContainer>
    </Container>

    <Dialog
        open={open2}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose2}
      >
        <DialogTitle sx={{ textAlign: 'center' }}>Update deposit status</DialogTitle>
        <DialogContent>
          {selectedDetails && fundingType && (
            <Box sx={{ mb: 2, p: 2, bgcolor: 'action.hover', borderRadius: 1 }}>
              <Typography variant="subtitle2" gutterBottom>
                {fundingType.gateway} · {fundingType.status}
              </Typography>
              <Typography variant="body2">USD: {selectedDetails.usd}</Typography>
              <Typography variant="body2">Units: {selectedDetails.coinUnits}</Typography>
              <Typography variant="body2">Rate: {selectedDetails.rate}</Typography>
              {selectedDetails.note && (
                <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
                  {selectedDetails.note}
                </Typography>
              )}
              {fundingType.status === 'processing' && fundingStatus === 'successful' && (
                <Typography variant="caption" color="warning.main" display="block" sx={{ mt: 1 }}>
                  Approving will convert USD to coin units at the current rate in coin_rate_changes.
                </Typography>
              )}
            </Box>
          )}
          <FormControl fullWidth sx={{ m: 1 }}>
            <InputLabel htmlFor="status">Status</InputLabel>
                <Select
                    onChange={(e) => setfundingStatus(e.target.value)}
                    labelId="status"
                    id="status"
                    name="status"
                    label="Status"
                    value={fundingStatus}
                    >
                    <MenuItem value="">Select status</MenuItem>
                    <MenuItem value="pending">pending</MenuItem>
                    <MenuItem value={fundingType?.status === 'processing' ? 'successful' : 'approved'}>
                      Approve {fundingType?.status === 'processing' ? '(successful)' : ''}
                    </MenuItem>
                    <MenuItem value="declined">declined</MenuItem>
                </Select>
            </FormControl>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose2}>Cancel</Button>
            <Button onClick={() => updatefunding()} disabled={!fundingStatus} color="primary" variant="contained">
              {isUpdating ? 'Updating...' : 'Update status'}
            </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
